import { render, staticRenderFns } from "./WorkFlowsManager.vue?vue&type=template&id=794e020c&scoped=true&"
import script from "./WorkFlowsManager.vue?vue&type=script&lang=ts&"
export * from "./WorkFlowsManager.vue?vue&type=script&lang=ts&"
import style0 from "./WorkFlowsManager.vue?vue&type=style&index=0&id=794e020c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794e020c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDivider,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VTextField})
